export const routes = {
    index : '/',
    about : '/about',
    packages : '/packages',
    packageDetails : '/packageDetails',
    news : '/news',
    contact: '/contact',
    service:'/service',
    hire: '/hire',
    career: '/career',
    faq: '/faq',
    newsdetail: '/newsdetail',
    feedback: '/feedback',
    phonemenu: '/phonemenu',
    verticals: '/verticals',
}